import { useEffect, useState } from 'react'

export const useElementHeight = <T extends HTMLElement>() => {
  const [element, setElement] = useState<T | null>(null)
  const [height, setHeight] = useState(0)

  useEffect(() => {
    if (!element) {
      return
    }
    const update = () => setHeight(element.getBoundingClientRect().height)
    update()
    if (typeof ResizeObserver === 'undefined') {
      return
    }
    const observer = new ResizeObserver(update)
    observer.observe(element)
    return () => observer.disconnect()
  }, [element])

  return { ref: setElement, height }
}
